export type ContentLocale = 'fr' | 'en';

export const CONTENT_LOCALES: { value: ContentLocale; label: string }[] = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'English' },
];

const STORAGE_KEY = 'certexam-locale';

export function getContentLocale(): ContentLocale {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'en' ? 'en' : 'fr';
}

export function setContentLocale(locale: ContentLocale): void {
  localStorage.setItem(STORAGE_KEY, locale);
}

export function pickLocalizedText(
  locale: ContentLocale,
  french?: string | null,
  english?: string | null,
): string {
  if (locale === 'en' && english?.trim()) return english.trim();
  return french?.trim() || english?.trim() || '';
}
